/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Row, Col, message, Card, Menu, Dropdown, Button } from "antd";
import Layout from "../../../layouts/MocoLayout";
import { NavigationMenuCard } from "../../../components/ui";
import { ChartCard } from "../../../components/widget";
import oRest from "../../../apis/rest";
import config from "./index.config";

const API_URL = "webhook/dataquery/?qname=";

const Page = () => {
  const [cards, setCards] = useState(config.cards);
  const [selectedProvince, setProvince] = useState("");
  const [provinceMenu, setProvinceMenu] = useState([]);

  const toPascalCase = (params) => {
    return params.charAt(0).toUpperCase() + params.slice(1).toLowerCase();
  };

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}survey5agama_list_provinsi`;
      oRest
        .get(api)
        .then(({ data }) => {
          setProvinceMenu(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.institusiFormal.queryName}&PROVINSI=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => a.count - b.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              institusiFormal: {
                ...card.chart.institusiFormal,
                options: {
                  ...card.chart.institusiFormal.options,
                  chartOption: {
                    ...card.chart.institusiFormal.options.chartOption,
                    yAxis: {
                      ...card.chart.institusiFormal.options.chartOption.yAxis,
                      data: data.map((e) => e.pendidikan_formal),
                    },
                    series: [
                      {
                        ...card.chart.institusiFormal.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.institusiNonFormal.queryName}&PROVINSI=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => a.count - b.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              institusiNonFormal: {
                ...card.chart.institusiNonFormal,
                options: {
                  ...card.chart.institusiNonFormal.options,
                  chartOption: {
                    ...card.chart.institusiNonFormal.options.chartOption,
                    yAxis: {
                      ...card.chart.institusiNonFormal.options.chartOption
                        .yAxis,
                      data: data.map((e) => e.pendidikan_nonformal),
                    },
                    series: [
                      {
                        ...card.chart.institusiNonFormal.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.jumlahPendidik.queryName}&PROVINSI=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => a.val - b.val);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              jumlahPendidik: {
                ...card.chart.jumlahPendidik,
                options: {
                  ...card.chart.jumlahPendidik.options,
                  chartOption: {
                    ...card.chart.jumlahPendidik.options.chartOption,
                    xAxis: {
                      ...card.chart.jumlahPendidik.options.chartOption.xAxis,
                      data: data.map((e) => e.val),
                    },
                    series: [
                      {
                        ...card.chart.jumlahPendidik.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.jumlahSantri.queryName}&PROVINSI=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data.forEach((itemData) => {
            itemData.santri_mukim = itemData.santri_mukim ?? 0;
            itemData.santri_nonmukim = itemData.santri_nonmukim ?? 0;
          });
          data = data.sort((a, b) => a.total - b.total);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              jumlahSantri: {
                ...card.chart.jumlahSantri,
                options: {
                  ...card.chart.jumlahSantri.options,
                  chartOption: {
                    ...card.chart.jumlahSantri.options.chartOption,
                    xAxis: {
                      ...card.chart.jumlahSantri.options.chartOption.xAxis,
                      data: data.map((e) => e.total),
                    },
                    series: [
                      {
                        ...card.chart.jumlahSantri.options.chartOption
                          .series[0],
                        data: data.map((e) => e.santri_mukim),
                      },
                      {
                        ...card.chart.jumlahSantri.options.chartOption
                          .series[1],
                        data: data.map((e) => e.santri_nonmukim),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.kapasitasMasjid.queryName}&PROVINSI=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => a.val - b.val);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              kapasitasMasjid: {
                ...card.chart.kapasitasMasjid,
                options: {
                  ...card.chart.kapasitasMasjid.options,
                  chartOption: {
                    ...card.chart.kapasitasMasjid.options.chartOption,
                    xAxis: {
                      ...card.chart.kapasitasMasjid.options.chartOption.xAxis,
                      data: data.map((e) => e.val),
                    },
                    series: [
                      {
                        ...card.chart.kapasitasMasjid.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.ruangSantri.queryName}&PROVINSI=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data.forEach((itemData) => {
            itemData.santri_putra = itemData.santri_putra ?? 0;
            itemData.santri_putri = itemData.santri_putri ?? 0;
          });
          data = data.sort((a, b) => a.total - b.total);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              ruangSantri: {
                ...card.chart.ruangSantri,
                options: {
                  ...card.chart.ruangSantri.options,
                  chartOption: {
                    ...card.chart.ruangSantri.options.chartOption,
                    xAxis: {
                      ...card.chart.ruangSantri.options.chartOption.xAxis,
                      data: data.map((e) => e.total),
                    },
                    series: [
                      {
                        ...card.chart.ruangSantri.options.chartOption.series[0],
                        data: data.map((e) => e.santri_putra),
                      },
                      {
                        ...card.chart.ruangSantri.options.chartOption.series[1],
                        data: data.map((e) => e.santri_putri),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.jumlahPerpustakaan.queryName}&PROVINSI=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort(
            (a, b) => a.sarana_num_perpustakaan - b.sarana_num_perpustakaan
          );
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              jumlahPerpustakaan: {
                ...card.chart.jumlahPerpustakaan,
                options: {
                  ...card.chart.jumlahPerpustakaan.options,
                  chartOption: {
                    ...card.chart.jumlahPerpustakaan.options.chartOption,
                    xAxis: {
                      ...card.chart.jumlahPerpustakaan.options.chartOption
                        .xAxis,
                      data: data.map((e) => e.sarana_num_perpustakaan),
                    },
                    series: [
                      {
                        ...card.chart.jumlahPerpustakaan.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.sdmTeknologi.queryName}&PROVINSI=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => a.count - b.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              sdmTeknologi: {
                ...card.chart.sdmTeknologi,
                options: {
                  ...card.chart.sdmTeknologi.options,
                  chartOption: {
                    ...card.chart.sdmTeknologi.options.chartOption,
                    yAxis: {
                      ...card.chart.sdmTeknologi.options.chartOption.yAxis,
                      data: data.map((e) => e.sumber_daya_teknologi),
                    },
                    series: [
                      {
                        ...card.chart.sdmTeknologi.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince]);

  const handleFilterProvinsi = (value) => {
    setProvince(value.key === "all" ? "" : value.key);
  };

  const provinceDropdownMenu = (
    <Menu onClick={handleFilterProvinsi}>
      <Menu.Item key="all">Nasional</Menu.Item>
      {provinceMenu
        ?.map((e) => e.lembaga_provinsi)
        .sort((a, b) =>
          // eslint-disable-next-line no-nested-ternary
          a > b ? 1 : b > a ? -1 : 0
        )
        .map((e) => {
          return <Menu.Item key={e}>{toPascalCase(e)}</Menu.Item>;
        })}
    </Menu>
  );

  return (
    <section id="Pendidikan">
      <Layout>
        <NavigationMenuCard
          menu={[
            { title: "Sebaran", path: "/pondok-pesantren" },
            { title: "Pendidikan", path: "/pondok-pesantren/pendidikan" },
            { title: "Dakwah", path: "/pondok-pesantren/dakwah" },
            {
              title: "Pemberdayaan Masyarakat",
              path: "/pondok-pesantren/pemberdayaan-masyarakat",
            },
            {
              title: "Penyajian dan Pencarian",
              path: "/pondok-pesantren/penyajian-pencarian",
            },
          ]}
        />
        <Row
          justify="end"
          align="top"
          gutter={[32, 24]}
          style={{ padding: "8px 0" }}
        >
          <Col>
            <Dropdown
              overlay={provinceDropdownMenu}
              overlayStyle={{ height: 300, overflowY: "auto" }}
            >
              <Button
                size="large"
                shape="round"
                style={{
                  backgroundColor: "#1B6FBA",
                  color: "#fff",
                }}
              >
                Pilih provinsi &nbsp;
                <DownOutlined />
              </Button>
            </Dropdown>
          </Col>
        </Row>
        <Row gutter={[24, 24]} style={{ padding: "8px 0" }}>
          <Col span={24}>
            <Card
              style={{
                borderRadius: 16,
              }}
            >
              <span
                style={{
                  fontSize: 26,
                  fontWeight: 500,
                  color: "#1B6FBA",
                }}
              >
                {`Sebaran Institusi Pendidikan Pesantren di ${
                  selectedProvince === ""
                    ? "Seluruh Provinsi"
                    : `Provinsi ${selectedProvince}`
                }`}
              </span>
            </Card>
          </Col>
          <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
            <ChartCard {...cards.chart.institusiFormal} />
          </Col>
          <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
            <ChartCard {...cards.chart.institusiNonFormal} />
          </Col>
          <Col span={24} style={{ padding: "0 8px" }}>
            <Card
              style={{
                borderRadius: 16,
              }}
            >
              <span
                style={{
                  fontSize: 26,
                  fontWeight: 500,
                  color: "#1B6FBA",
                }}
              >
                {`Statistik Tendik & Siswa Pesantren di ${
                  selectedProvince === ""
                    ? "Seluruh Provinsi"
                    : `Provinsi ${selectedProvince}`
                }`}
              </span>
            </Card>
          </Col>
          <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
            <ChartCard {...cards.chart.jumlahPendidik} />
          </Col>
          <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
            <ChartCard {...cards.chart.jumlahSantri} />
          </Col>
          <Col span={24} style={{ padding: "0 8px" }}>
            <Card
              style={{
                borderRadius: 16,
              }}
            >
              <span
                style={{
                  fontSize: 26,
                  fontWeight: 500,
                  color: "#1B6FBA",
                }}
              >
                {`Sarana & Prasarana di ${
                  selectedProvince === ""
                    ? "Seluruh Provinsi"
                    : `Provinsi ${selectedProvince}`
                }`}
              </span>
            </Card>
          </Col>
          <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
            <ChartCard {...cards.chart.kapasitasMasjid} />
          </Col>
          <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
            <ChartCard {...cards.chart.ruangSantri} />
          </Col>
          <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
            <ChartCard {...cards.chart.jumlahPerpustakaan} />
          </Col>
          <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
            <ChartCard {...cards.chart.sdmTeknologi} />
          </Col>
        </Row>
      </Layout>
    </section>
  );
};

export default Page;
